angular.module('rjmNg.services').factory('userEventService', [
  "$http"
  "app"
  "$url"
  (
    $http
    app
    $url
  ) ->
    userEventService = {}

    userEventService.getEvents = (eventType) ->
      $http.get(
        $url("/user/#{app.getUserId()}/userevent/#{eventType}")
      )

    userEventService.logEvent = (eventType) ->
      $http(
        url: $url("/user/#{app.getUserId()}/userevent"),
        method: "POST",
        data:
          eventType: eventType,
          clientId: app.getClientId()
      )

    #9 is COMPLETED_NEW_DASHBOARD_GUIDED_TOUR event
    userEventService.getTourCompletedEvents = -> userEventService.getEvents 9
    userEventService.logTourCompleted = -> userEventService.logEvent 9

    #10 is SKIPPED_NEW_DASHBOARD_GUIDED_TOUR
    userEventService.getTourSkippedEvents = -> userEventService.getEvents 10
    userEventService.logTourSkipped = -> userEventService.logEvent 10

    #13 is DISMISSED_TOUR
    userEventService.getDismissedTour = -> userEventService.getEvents 13
    userEventService.logDismissedTour = -> userEventService.logEvent 13

    #14 is COMPLETED_VRB_TOUR
    userEventService.getCompletedVrbTour = -> userEventService.getEvents 14
    userEventService.logCompletedVrbTour = -> userEventService.logEvent 14

    #16 is COMPLETED_DASH_TOUR
    userEventService.getCompletedDashTour = -> userEventService.getEvents 16
    userEventService.logCompletedDashTour = -> userEventService.logEvent 16

    #17 is BRING_TOUR_BACK
    userEventService.getBringTourBack = -> userEventService.getEvents 17
    userEventService.logBringTourBack = -> userEventService.logEvent 17

    userEventService

  ]
)
